$(document).ready(function () {
  $(document).on("click", ".tab-main-list-bas li", function (e) {
    // remove active class from all li
    $(".tab-main-list-bas li").removeClass("active");

    // add active class to clicked li
    $(this).addClass("active");
    // get the data-tab attribute of clicked li
    var tabId = $(this).data("id");

    $(".bas-tab-item").hide();
    $(".bas-tab-item." + tabId).show();
  });

  $("body.template-page.better-aging-serum .product-info__description").each(function () {
    var $pTag = $(this).find("p").first(); // Just the first <p>
    var fullText = $pTag.text();
  
    if (fullText.length > 150) {
      var shortText = fullText.substring(0, 150) + "...";
  
      // Store full text in a data attribute for later use
      $pTag.addClass("full-text").hide(); // hide full text
  
      // Add preview text with "Read More"
      var previewHtml = `
        <p class="preview-text">
          ${shortText} <a href="#" class="read-more-link">Read More</a>
        </p>
      `;
  
      // Add "Read Less" inside the full text block
      var fullHtml = `
        <p class="full-text">
          ${fullText} <a href="#" class="read-less-link">Read Less</a>
        </p>
      `;
  
      // Replace the original <p> with new elements
      $(this).empty().append(previewHtml).append(fullHtml);
      $(this).find(".full-text").hide();
    }
  });
  
  // Show full text
  $(document).on("click", ".read-more-link", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".product-info__description");
    $container.find(".preview-text").hide();
    $container.find(".full-text").show();
  });
  
  // Show preview text
  $(document).on("click", ".read-less-link", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".product-info__description");
    $container.find(".full-text").hide();
    $container.find(".preview-text").show();
  });
  
});


document.addEventListener("DOMContentLoaded", () => {
  const init = () => {
    const crispChat = document.querySelector('#crisp-chatbox-chat');
    const cornerCart = document.querySelector('.widgets-by-corner.corner-widget #corner-cowi-cart-button-launcher-wrapper');

    if (!crispChat || !cornerCart) return setTimeout(init, 500); // retry until both exist

    const originalZ = window.getComputedStyle(cornerCart).zIndex;

    const updateZIndex = () => {
      const isVisible = crispChat.getAttribute('data-visible') === 'true';
      cornerCart.style.setProperty('z-index', isVisible ? '0' : originalZ, 'important');
    };

    updateZIndex();
    new MutationObserver(updateZIndex).observe(crispChat, { attributes: true, attributeFilter: ['data-visible'] });
  };

  init();
});


(function setupSplideGlobalTouchFix() {
  // Only do anything if there is at least one Splide on the page
  if (!document.querySelector('.splide')) return;

  // Non-passive touchmove: tells Chrome/Android "JS might handle this"
  window.addEventListener(
    'touchmove',
    function (e) {
      if (!e.target.closest('.splide')) return;
      // No preventDefault here – the important bit is passive:false.
    },
    { passive: false }
  );

  // Same for wheel (mouse wheel / trackpad inside sliders)
  window.addEventListener(
    'wheel',
    function (e) {
      if (!e.target.closest('.splide')) return;
    },
    { passive: false }
  );
})();
